import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';

/**
 * OptimoOpticasCover - Pantalla Gigante del Estadio (/screen Tile 49)
 * Dinámica: 'Rasca y Gana - Optimo Ópticas'
 * 
 * Replica con fidelidad el prototipo oficial de screen.html:
 * - Efecto de Lente Animado con clip-path dinámico y aro físico a 60 FPS
 * - Peter Parker asomándose en la esquina inferior izquierda
 * - QR Pulsante dinámico apuntando a ${window.location.origin}/psl-optopticas?s=obs
 *   con fallback visual en caso de contingencia.
 */
const OptimoOpticasCover = ({ payload }) => {
    const [qrError, setQrError] = useState(false);

    // Determinamos la URL para el aficionado en el estadio
    const getQrUrl = () => {
        if (payload?.qrUrl) return payload.qrUrl;
        if (payload?.data?.qrUrl) return payload.data.qrUrl;
        if (typeof window !== 'undefined' && window.location?.origin) {
            return `${window.location.origin}/psl-optopticas?s=obs`;
        }
        return 'https://patrick.adsl.mx/psl-optopticas?s=obs';
    };

    const qrUrl = getQrUrl();

    return (
        <div className="optimo-opticas-screen" data-testid="optimo-opticas-screen">
            {/* Sección de texto y lentes */}
            <div className="text-section optimo-text-section">
                
                {/* Logo Header */}
                <div className="optimo-logo-header">
                    <img
                        src="/img/optimoopticas/logo-optimo-opticas-secundario-rectangulo.png"
                        alt="Optimo Ópticas"
                        className="optimo-logo-img"
                    />
                </div>

                {/* Textos Principales y Lente Explorador */}
                <div className="optimo-main-texts">
                    <div className="lens-container">
                        {/* Texto Base Borroso */}
                        <h1 className="lens-text-blurred">
                            ESCANEA Y OBTÉN<br />UN REGALO QUE TENEMOS PARA TI
                        </h1>

                        {/* Texto Nítido revelado por el lente animado */}
                        <h1 className="lens-text-sharp">
                            ESCANEA Y OBTÉN<br />UN REGALO QUE TENEMOS PARA TI
                        </h1>

                        {/* Aro de cristal interactivo con sombra y borde físico */}
                        <div className="lens-ring" />
                    </div>
                </div>

                {/* Peter Parker asomándose desde el borde inferior izquierdo */}
                <div
                    className="peter-parker-screen"
                    style={{ backgroundImage: "url('/img/optimoopticas/peterScreen.png')" }}
                    aria-label="Peter Parker Optimo Ópticas"
                />
            </div>

            {/* Sección de Código QR con animación pulsante */}
            <div className="qr-section">
                <div className="qr-container">
                    {/* {!qrError ? (
                        <QRCodeSVG
                            value={qrUrl}
                            size={800}
                            level="Q"
                            includeMargin={true}
                            className="qr-code"
                            onError={() => setQrError(true)}
                        />
                    ) : (
                        <img
                            src="/img/optimoopticas/qr.png"
                            alt="Código QR Dinámica Optimo Ópticas"
                            className="qr-code"
                        />
                    )} */}
                    <img
                        src="/img/optimoopticas/qr.png"
                        alt="Código QR Dinámica Optimo Ópticas"
                        className="qr-code"
                    />
                </div>
            </div>

            {/* Pie de página oficial de pantalla */}
            {/* <p className="optimo-screen-footer FooterCredits" style={{ fontSize: '22px' }}>
                Powered by Interaktia
            </p> */}
        </div>
    );
};

export default OptimoOpticasCover;
export { OptimoOpticasCover };
